import { useMutation, useQuery } from "react-query";
import { sprayTimelinePost } from "../actions/timeline";
import {
	fetchTransactionHistory,
	fetchWalletStat,
	fetchWithdrawable,
	fundWallet,
	initializeTransaction,
} from "../actions/wallet";

export const useInitializePayment = () => {
	return useMutation(initializeTransaction);
};

export const useTransactionHistory = ({ start, end, type, currencyCode }) => {
	return useQuery(
		["transactionHistory", { start, end, type, currencyCode }],
		() =>
			fetchTransactionHistory({
				start,
				end,
				type,
				currencyCode,
			}),
		{
			refetchOnWindowFocus: false,
		}
	);
};

export const useTransactionStats = ({
	start,
	end,
	type,
	currencyCode,
	transaction_type,
	frequency,
}) => {
	return useQuery(
		[
			"transactionHistory",
			{ start, end, currencyCode, transaction_type, frequency },
		],
		() =>
			fetchWalletStat({
				start,
				end,
				type,
				currencyCode,
				transaction_type,
				frequency,
			}),
		{
			refetchOnWindowFocus: false,
		}
	);
};

export const useWalletBalance = ({ currencyCode }) => {
	return useQuery(
		["Withdrawable", { currencyCode }],
		() => fetchWithdrawable({ currencyCode }),
		{
			notifyOnChangeProps: [currencyCode],
			refetchOnWindowFocus: false,
		}
	);
};



export const useFundWallet = () => {
	return useMutation(fundWallet);
};

export const useSprayTimeline = () => {
	return useMutation(sprayTimelinePost);
};
